// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2QtPf","buttons":"Footer_buttons__2prOw"};